import { Component, Input } from '@angular/core';
import { StatusPill } from '../../../../models/shared/status-pill';
import { InvestmentInstructions } from '../../../../models/transactions/investment-instructions';

@Component({
  selector: 'app-account-investment-instructions-card',
  templateUrl: './account-investment-instructions-card.component.html',
  styleUrls: ['./account-investment-instructions-card.component.scss']
})
export class AccountInvestmentInstructionsCardComponent {
  @Input() instruction!: InvestmentInstructions;
  @Input() accountName?: string;
  public activePill = new StatusPill(0, $localize`Active`, '#0D5D4B', '#E8F3F1');
  public inactivePill = new StatusPill(0, $localize`Inactive`, '#666666', '#F7F7F7');
}
